import * as React from 'react';
import styles from './DashboardView.module.css';

interface DashboardViewProps {
  title?: string;
  rightComponent?: any;
  children: React.ReactNode;
}

const DashboardView: React.FC<DashboardViewProps> = ({
  children,
  title,
  rightComponent,
}) => {
  return (
    <div className={styles.DashboardView}>
      {(title || rightComponent) && (
        <div className={styles.DashboardHeader}>
          {title && <h1>{title}</h1>}
          {rightComponent}
        </div>
      )}
      {children}
    </div>
  );
};

export default DashboardView;
